import { useEffect, useRef } from "react";
import * as THREE from "three";

function Gizmo({ angles, onPlaneClick }) {
    const mountRef = useRef(null);
    var degree2Radian = Math.PI / 180;
    var gbox = null;
    function addPlane(side) {
        var s = 0.4;
        var l = 0.8;
        gbox.scale.set(s, s, s);
        let geometry = new THREE.PlaneGeometry(l, l);
        let textureLoader = new THREE.TextureLoader();
        let texture = textureLoader.load(process.env.PUBLIC_URL + '/images/' + side + '.jpg');
        let material = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide });
        let plane = new THREE.Mesh(geometry, material);
        if (side == 'front') {
            plane.position.z = 0.4;
        } else if (side == 'back') {
            plane.position.z = -0.4;
            plane.rotation.y = -180 * degree2Radian;
        } else if (side == 'left') {
            plane.position.x = 0.4;
            plane.rotation.y = 90 * degree2Radian;
        } else if (side == 'right') {
            plane.position.x = -0.4;
            plane.rotation.y = -90 * degree2Radian;
        } else if (side == 'up') {
            plane.position.y = 0.4;
            plane.rotation.x = -90 * degree2Radian;
        } else if (side == 'down') {
            plane.position.y = -0.4;
            plane.rotation.x = 90 * degree2Radian;
        }
        plane.name = side;
        gbox.add(plane);
    }

    useEffect(() => {
        gbox = new THREE.Group();
        const scene = new THREE.Scene();
        scene.add(gbox);
        addPlane('front');
        addPlane('back');
        addPlane('left');
        addPlane('right');
        addPlane('up');
        addPlane('down');

        const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 4000);
        camera.position.set(0, 0, 1);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        mountRef.current.appendChild(renderer.domElement);
        let gcanvas = renderer.domElement;
        gcanvas.classList.add('gcanvas');
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();

        function spinModel(loc) {
            var finalRotation;
            if (loc == 'front') {
                finalRotation = { x: 0, y: 0, z: 0 };
            } else if (loc == 'back') {
                finalRotation = { x: 0, y: 180 * degree2Radian, z: 0 };
            } else if (loc == 'left') {
                finalRotation = { x: 0, y: -90 * degree2Radian, z: 0 };
            } else if (loc == 'right') {
                finalRotation = { x: 0, y: 90 * degree2Radian, z: 0 };
            } else if (loc == 'up') {
                finalRotation = { x: 90 * degree2Radian, y: 0, z: 0 };
            } else if (loc == 'down') {
                finalRotation = { x: -90 * degree2Radian, y: 0, z: 0 };
            }
            onPlaneClick(finalRotation);
        }

        const onClick = (e) => {
            const rect = gcanvas.getBoundingClientRect();
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
            raycaster.setFromCamera(mouse, camera);
            const intersects = raycaster.intersectObjects(gbox.children);
            if (intersects.length > 0) {
                spinModel(intersects[0].object.name);
            }
        };
        gcanvas.addEventListener("click", onClick);
        const animate = () => {
            gbox.rotation.set(angles.x, angles.y, 0);
            renderer.render(scene, camera);
            requestAnimationFrame(animate);
        };
        animate();

        return () => {
            mountRef.current.removeChild(renderer.domElement);
            renderer.dispose();
        };
    }, []);

    return <div className="gizmo" ref={mountRef} style={{ width: "100%", height: "100%" }} />;
}

export default Gizmo;
